
import { Modal } from "reactstrap";
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import React, { useState, useEffect } from "react";




const VaccumPump =({
    isOpen,
    onClose,
    pumpName,
    container,
  }: {
    isOpen: boolean;
    onClose: () => void;
    pumpName: string;
    style?: React.CSSProperties;
         container?: HTMLElement | null;
  }) =>{



const [PumpData, setpumpdata] = useState<any[]>([]);  
const getAllPumpingStations = async () => {
  try {
    const response = await ApiService.axiosApi(`/tags`, {
      method: 'GET'
    });

    if (response.success) {
       
      
      setpumpdata(response.data); 
       
    } else {
       console.log('Failed to fetch pumping stations');
    }

  } catch (error) {
    console.error('Error fetching pumping stations:', error);
     console.log('Error fetching pumping stations');
  }
};

useEffect(() => {
    getAllPumpingStations();

    const vaccumInterval = setInterval(()=>(
       getAllPumpingStations()
    ),5000)
    return () => clearInterval(vaccumInterval);
  }, []);

const pumpDisplayNames: { [key: string]: string } = {
  VAC_PMP1: "Vacuum Pump 1",
  VAC_PMP2: "Vacuum Pump 2",
};

     
    return(
         <>
         <Modal isOpen={isOpen} size='lg' centered toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class"  >
            <div className="panel-vaccum">

    <div className="panel-header-vaccum">  {pumpDisplayNames[pumpName] || pumpName}
      <button className="refreshButtonVaccum"onClick={getAllPumpingStations} style={{ cursor: 'pointer' }}>&#x21bb;</button>
    <button className="closeVaccum" aria-label="Close" onClick={onClose}>&times;</button>

    </div>


    <div className="section-vaccum">
      <strong style={{color:'white'}}>SYSTEM IN WEB SCADA</strong>
    </div>

 
<div className="section-vaccum">
  <div className="status-header-vaccum" style={{ color: 'white' }}>INPUT BREAKER</div>
  <div className="status-list-vaccum">
    
    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_HAUTO` && t.value === 'True') ? 'green' : 'grey' }}></span>
      AUTO
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_ON` && t.value === 'True') ? 'green' : 'grey' }}></span>
      ON STATUS
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_OFF` && t.value === 'True') ? 'red' : 'grey' }}></span>
      OFF STATUS
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_TRP` && t.value === 'True') ? 'yellow' : 'grey' }}></span>
      TRIP STATUS
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_RMT` && t.value === 'True') ? 'green' : 'grey' }}></span>
      REMOTE STATUS
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_RMT` && t.value === 'FALSE') ? 'green' : 'grey' }}></span>
      INTERLOCK OK
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_RDY` && t.value === 'True') ? 'green' : 'grey' }}></span>
      READY STATUS (MANUAL MODE)
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_HLTHY` && t.value === 'True') ? 'green' : 'grey' }}></span>
      HEALTHY STATUS (AUTO MODE)
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_FBLT` && t.value === 'True') ? 'yellow' : 'grey' }}></span>
      FEEDBACK FAULT
    </div>

    <div className="status-item-vaccum1">
      <span className="status-box-vaccum1" style={{ backgroundColor: PumpData.find(t => t.name === `${pumpName}_ANYFLT` && t.value === 'True') ? 'yellow' : 'grey' }}></span>
      ANY FAULT
    </div>

  </div>
</div>

    
    </div>
 
  </Modal>
         </>
    )
}

export default VaccumPump;


